import { render, staticRenderFns } from "./adminTagTools.vue?vue&type=template&id=455d2204&"
import script from "./adminTagTools.vue?vue&type=script&lang=js&"
export * from "./adminTagTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports